import { useApi } from "@/hooks/useApi";

import { transformData } from "@/utils/transformData";
import { paginatedIdcsMap } from "@/utils/mappings/paginatedIdcs";

import { Additional, ReactSelect, ReactSelectProps } from "@/components/Selects/ReactSelect";

type Props = ReactSelectProps;

type TransformedPaginationIdcs = TransformedGenericPagination<Idc>;

export function IdcsSelect({ ...rest }: Props) {
	const { api } = useApi();

	async function handleGetIdcs(page?: number, search?: string) {
		try {
			const { data } = await api.get("/cids", {
				params: {
					page: page || 1,
					search,
				},
			});

			const transformedIdcs = transformData<TransformedPaginationIdcs>(
				data,
				paginatedIdcsMap
			);

			return transformedIdcs;
		} catch (error) {
			console.log(error);
			return {} as TransformedPaginationIdcs;
		}
	}

	const loadAsyncIdcsOptionsProps = {
		additional: {
			page: 1,
		},
		isAsyncPaginate: true,
		async loadOptions(search: string, _: Idc, { page }: Additional) {
			const idcs = await handleGetIdcs(page, search);

			return {
				options: idcs?.results.map((idc) => ({
					value: idc.code,
					label: `${idc.code} - ${idc.description}`,
				})),
				hasMore: idcs.meta?.currentPage < idcs.meta?.lastPage || false,
				additional: {
					page: page + 1,
				},
			};
		},
	};

	return <ReactSelect isSolid {...loadAsyncIdcsOptionsProps} {...rest} />;
}
